var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_255",
    transform: "scale(0.00735294)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_255",
    width: 136,
    height: 136,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAYAAAA8uqNSAAAEFklEQVR4nO3dzW4bZRSH8f9E3Ap2L8HTXe4hnXEmpNCqIW0CqHzELgghC1QBFR+VJ3xV0CLxUSC9ga7okm1BasU2XsS7LquK1odVEZWqE6jfmXfGfX4XcN538eg4HtuKBAAAAAAAAAAAAAAAgEWSzDvgt19esRAXwZOwazfv3Cs2Ny/9VdUJz1Q1GJXbu3vrj2JzdON+lYcsVTkc1TDZz/s6WF2uOA6JQNrH7OpE07Us23tQx3EE0iJm9sN+Ml2vKw6JQFrEvpsk0+frjEMikFYw05V9TU/UHYfEu5jmM7t8/Xa5MRppFuN4AmkwM/s6zcsXJUV71sRLTHNdih2HRCCNZKYve9n4tCLHIRFI45jp8zQfb6kBcUgE0ihmNk7z8UsKFMeg312ZdwaBNIXZxTQvzypQHOeK7rEk0fa8cwikAUz2SS8vX1XAOMy0FWIWgcRms4/SrHw91LjhajcLFYdEIFGZ6UIv390JNW+n38klnQk1TyKQaGbSB2k+HoaaNyw6/aUkOR1q3kMEEoFpdv5oNn4z1Lxh0enLks1Q8/6NQGpn76bZ7tuhpu2sPrtaVRxSAz+L6WXjub8n+7QY9o8Ukm1UeQYbpKWG/SOFkmrjkBq4QXC4QdFdk9mpOs5ig7TMoOiuJaZa4pDYIK0y6HfWE9PJOs9kg7TEoN9ZT5Kk1jgkNkgrDIvOcVlyIsbZbJCGixmHRCDNFzEOiUBwCAKBi0DgIhC4CAQuAoGLQOAiELgIBC4CgYtA4Fr4T3OHq91f6zzvw6t/Ltd5XtXYIHARCFwEAheBwEUgcBEIXAQCF4HARSBwEQhcBAIXgcBFIHARCFwEAheBwEUgcBEIXAQCF4HARSBwEQhcBAIXgcBFIHARCFwEAtfC/zZ30X4rWzc2CFwEAheBwEUgcBEIXAQCF4HA1ahAZqb3Yt8Bj2rMgzLT7PzRfPed2PfAo5qxQWz2fsh/V45wogdipgu9fPet2PfA40V9iTGzj9O8HMa8A3zRNoiZPk3z8o1Y5+O/ibNBzC6meflalLPxv9S+Qcxs3COO1qg3ELPP0rw8K8lqPRdPrLZATPZFLy9fFnG0Sj2BmH2VZuW2iKN1Kg/EpG96eXlGxNFK1b6LMbuc5uWGAsUx6HdXkiVtyZSEmIfDVRaIma5cv00cbVdJICb7dpJMN0YjzULMG/S7K0mibV6k6hf8bxAzfT/R9FSW7T0IMe+fOBBF0EBM+nGSHLxAHIsjWCBm+mmig+PEsVhCBbI3SQ6eI47FEyAQu3b31u8FcSymuQO5eedesTy6cT/EZYijeRrzTIE4qjHvj9ejf+VQIo4mi/6t9nNF95iZtmLfA48XdYMQR/NFC4Q42iFKIMTRHrUHQhwAAAAAAAAAAAAAAABAPH8DUXM8OUa7qNsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/Icon_Top.debb05bebb0ac56b865be1ae8bcfb8c9.svg";
export { ForwardRef as ReactComponent };